import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import axios from 'axios'

Vue.config.productionTip = false

axios.defaults.baseURL = 'http://localhost:8080';
Vue.prototype.$version = "2.17.0226";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
